var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStartBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 8492,
    transform: "translate(-846 -5447)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 604,
    transform: "translate(-846 -337)",
    fill: "url(#paint0_linear_2_4)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_4)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12.5,
    y: -13,
    width: 58,
    height: 58,
    rx: 12,
    fill: "#7F56D9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.8467 20.0773H13.18V11.9227H11.8467V20.0773ZM16.1533 20.0773L22.2827 16L16.1533 11.9227V20.0773ZM16.004 28C14.3453 28 12.7853 27.6853 11.324 27.056C9.86356 26.4258 8.59289 25.5707 7.512 24.4907C6.43111 23.4116 5.57556 22.1422 4.94533 20.6827C4.31511 19.2231 4 17.6636 4 16.004C4 14.3453 4.31467 12.7853 4.944 11.324C5.57422 9.86356 6.42933 8.59289 7.50933 7.512C8.58844 6.43111 9.85778 5.57556 11.3173 4.94533C12.7769 4.31511 14.3364 4 15.996 4C17.6547 4 19.2147 4.31467 20.676 4.944C22.1364 5.57422 23.4071 6.42933 24.488 7.50933C25.5689 8.58844 26.4244 9.85778 27.0547 11.3173C27.6849 12.7769 28 14.3364 28 15.996C28 17.6547 27.6853 19.2147 27.056 20.676C26.4258 22.1364 25.5707 23.4071 24.4907 24.488C23.4116 25.5689 22.1422 26.4244 20.6827 27.0547C19.2231 27.6849 17.6636 28 16.004 28ZM16 26.6667C18.9778 26.6667 21.5 25.6333 23.5667 23.5667C25.6333 21.5 26.6667 18.9778 26.6667 16C26.6667 13.0222 25.6333 10.5 23.5667 8.43333C21.5 6.36667 18.9778 5.33333 16 5.33333C13.0222 5.33333 10.5 6.36667 8.43333 8.43333C6.36667 10.5 5.33333 13.0222 5.33333 16C5.33333 18.9778 6.36667 21.5 8.43333 23.5667C10.5 25.6333 13.0222 26.6667 16 26.6667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_4",
    x: -24.5,
    y: -17,
    width: 82,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52849 0 0 0 0 0.566891 0 0 0 0 0.9125 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_4",
    x1: 1148.5,
    y1: 1311.69,
    x2: 714.938,
    y2: 120.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 8492,
    fill: "white",
    transform: "translate(-846 -5447)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStartBg);
export default __webpack_public_path__ + "static/media/ic_start_bg.0f1d50e244cb683feec77bb9abe61d9e.svg";
export { ForwardRef as ReactComponent };